// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table[data-v-4f414595]{margin-bottom:calc(var(--default-grid-baseline)*2);width:100%;color:var(--color-text-maxcontrast)}`, "",{"version":3,"sources":["webpack://./src/modules/sidebar/sections/Sidebar.vue"],"names":[],"mappings":"AAEA,uBACC,kDAAA,CACA,UAAA,CACA,mCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
